import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "period-controllers"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  const _component_app_button_radio_group = _resolveComponent("app-button-radio-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_app_dropdown, {
    modelValue: $options.currentPeriod,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.currentPeriod = $event),
    options: $props.periodSelectorOptions,
    boundary: "viewport"
  }, null, 8, ["modelValue", "options"]), $props.periodOptions ? (_openBlock(), _createBlock(_component_app_button_radio_group, {
    key: 0,
    options: $props.periodOptions,
    modelValue: $options.currentPeriodCategory,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.currentPeriodCategory = $event),
    valueField: "queryKey"
  }, null, 8, ["options", "modelValue"])) : _createCommentVNode("", true)]);
}